// extracted by mini-css-extract-plugin
export var boxItems = "_60-1";
export var button = "_60-5";
export var filterGroupBox = "_60-0";
export var icon = "_60-2";
export var iconSecondary = "_60-4";
export var iconWrapper = "_60-3";